import { render, staticRenderFns } from "./SupplierProductNewForm.vue?vue&type=template&id=af431da6&scoped=true"
import script from "./SupplierProductNewForm.vue?vue&type=script&lang=js"
export * from "./SupplierProductNewForm.vue?vue&type=script&lang=js"
import style0 from "./SupplierProductNewForm.vue?vue&type=style&index=0&id=af431da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af431da6",
  null
  
)

export default component.exports